import {
  GET_GROUPS,
  GET_GROUP_MEMBERS,
  CREATE_GROUP,
  UPDATE_GROUP,
  DELETE_GROUP,
  RESTORE_GROUP,
  GET_GROUP_MEMBERS_COUNT,
  GET_GROUP_DETAILS,
  REMOVE_MEMBERS,
} from './types';
import * as groupsSvc from 'services/groups.service';

export const getGroups = (query, reset) => ({
  type: GET_GROUPS,
  payload: {
    promise: groupsSvc.getGroups(query),
    query,
    reset,
  },
});

export const getGroup = (id, group_deleted) => ({
  type: GET_GROUP_DETAILS,
  payload: {
    promise: groupsSvc.getGroup(id, { group_deleted }),
    id,
  },
});

export const getGroupMembers = (query) => ({
  type: GET_GROUP_MEMBERS,
  payload: {
    id: query.group_hash,
    query,
    promise: groupsSvc.getGroupMembers(query),
  },
});

export const createGroup = (data, isCopy) => ({
  type: CREATE_GROUP,
  payload: {
    promise: groupsSvc.createGroup(data, isCopy),
  },
});

export const updateGroup = (id, payload) => ({
  type: UPDATE_GROUP,
  payload: {
    promise: groupsSvc.updateGroup(id, payload),
  },
});

export const restoreGroup = (id, params) => ({
  type: RESTORE_GROUP,
  payload: {
    promise: groupsSvc.updateGroup(id, { group_deleted: '0', ...params }),
    id,
  },
});

export const deleteGroup = (id, payload) => ({
  type: DELETE_GROUP,
  payload: {
    promise: groupsSvc.deleteGroup(id),
    id,
  },
});

export const getGroupMembersCount = (groupHash) => ({
  type: GET_GROUP_MEMBERS_COUNT,
  payload: {
    promise: groupsSvc.getGroupsMembersCount(groupHash),
  },
});

export const removeMembersFromGroup = (groupHash, membersHash) => ({
  type: REMOVE_MEMBERS,
  payload: {
    promise: groupsSvc.removeMembers(groupHash, membersHash),
    groupHash,
    membersHash,
  },
});
